<template>
  <page-list
    :list="list"
    :columns="changedColumns"
    :group-actions="groupActions"
    :single-actions="singleActions"
    :showSearchbox="showSearchbox"
    :showGroupActions="showGroupActions"
    :export-data-options="exportDataOptions">
    <template v-slot:group-actions-append>
      <date-time
        class="ml-2"
        :getParams.sync="dateParam"
        :dateMode.sync="dateMode"
        paramTimeFormatter="YYYY-MM-DDTZ"
        showStartMonthTip
        @refresh="fetchData" />
    </template>
    <template v-slot:table-prepend>
      <total-price :currencySign="currencySign" :total="total_amount" :secondary_total="total_secondary_amount" setSecondaryToAmount />
    </template>
  </page-list>
</template>

<script>
import * as R from 'ramda'
import TotalPrice from '@Bill/sections/TotalPrice'
import ContractMixin from '@Bill/mixins/contract'
import currencyRequest from '@Bill/mixins/currencyRequest'
import { getAmountColumns } from '@Bill/utils'
import TotalPriceMixin from '@Bill/mixins/totalPrice'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import { getResourceTypeFilter } from '@/utils/common/tableFilter'
import ColumnsMixin from '../mixins/columns'

export default {
  name: 'CloudDomainList',
  components: {
    TotalPrice,
  },
  mixins: [WindowsMixin, ListMixin, ColumnsMixin, currencyRequest, TotalPriceMixin, ContractMixin],
  props: {
    id: String,
    getParams: {
      type: Object,
      default: () => ({}),
    },
    cloudEnv: String,
    isAllowCreate: {
      type: Boolean,
      default: true,
    },
    hiddenActions: {
      type: Array,
      default: () => ([]),
    },
    billShared: Boolean,
    projectShared: Boolean,
  },
  data () {
    return {
      batchDeleteBill: true,
      dateMode: 'month',
      dateParam: {},
      list: this.$list.createList(this, {
        id: this.id,
        apiVersion: 'v1',
        idKey: 'resource_type',
        exportUseIdKey: true,
        resource: 'billsanalysises',
        getParams: this.getParam,
        fetchDataCb: this.getTotal,
        filterOptions: {
          resource_type: getResourceTypeFilter(),
        },
      }),
    }
  },
  computed: {
    changedColumns () {
      const columns = R.clone(this.columns)
      const amountColumns = getAmountColumns({
        disable_cost_conversion: this.currencyParams.disable_cost_conversion,
        dateMode: this.dateMode,
        amountContractColumn: this.billContractColumns[0] || null,
        currencySign: this.currencySign,
      })
      return [...columns, ...amountColumns]
    },
    exportDataOptions () {
      const items = this.changedColumns.map(item => {
        return {
          key: item.field,
          label: item.title,
          formatter: item.formatter,
        }
      })
      return {
        title: this.$t('bill.text_73'),
        downloadType: 'local',
        items,
      }
    },
  },
  watch: {
    currencyParams: {
      handler: function () {
        this.fetchData()
      },
      deep: true,
    },
    billShared () {
      this.fetchData()
    },
    projectShared () {
      this.fetchData()
    },
  },
  created () {
    this.initSidePageTab('overview')
    this.fetchData()
  },
  methods: {
    fetchData () {
      this.list.fetchData()
    },
    getParam () {
      const ret = {
        query_type: 'res_type_stat',
        start_date: this.$moment().startOf('month').format('YYYY-MM-DD') + 'TZ',
        end_date: this.$moment().endOf('month').format('YYYY-MM-DD') + 'TZ',
        ...this.currencyParams,
        ...(R.is(Function, this.getParams) ? this.getParams() : this.getParams),
        ...this.dateParam,
        ...(this.billContractParams || {}),
      }
      if (this.billShared) {
        ret.is_prepaid_amortizing = true
      } else {
        ret.is_prepaid_amortizing = false
      }
      if (this.projectShared) {
        ret.is_project_sharing = true
      } else {
        ret.is_project_sharing = false
      }
      return ret
    },
    handleOpenSidepage (row) {
      this.sidePageTriggerHandle(this, 'BillResourcetypeSidePage', {
        id: row.resource_type,
        resource: () => {
          return {
            data: Object.assign({}, row, { name: row.resource_type }),
          }
        },
        dateParam: this.dateParam,
        dateMode: this.dateMode,
      }, {
        list: this.list,
        hiddenActions: this.hiddenActions,
      })
    },
  },
}
</script>
